import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'hr_BA',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: false,
  },
  'fc13dbb8-5bc5-491b-8a5b-1b237aaa0e8a',
  ''
);
